import { API_URL_WHALESHARK_ARTICLES } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const getItems = () =>
  apiInstance({
    url: API_URL_WHALESHARK_ARTICLES,
    params: {
      order: "desc",
      sort: "createdAt",
    },
  });

export default getItems;
